import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="wygodne-zwroty"
export default class extends Controller {
  static values = {
    id: String,
  };

  connect() {
    if (!document.querySelector(`script[src*="allekurier"]`)) {
      const script = document.createElement("script");
      script.src = `https://cdn.allekurier.pl/mail-box/banner.js?hid=${this.idValue}`;
      script.async = true;
      script.referrerPolicy = "no-referrer-when-downgrade";
      document.body.appendChild(script);
    }
  }
}
